module.exports = __webpack_public_path__ + "static/media/logo-1-icon-white.3bc07646.svg";